import React, {FC, PropsWithChildren, useState} from 'react';
import classNames from 'classnames';
import {Screen} from 'pages/dashboard/components/FirstLook/Screens/Screen';
import {Endpoints, postValues} from 'utils/n8n';

import {Thumbs} from './Thumbs';

import * as styles from 'pages/dashboard/components/FirstLook/Screens/Factoid/styles.module.scss';

const pending = 'https://static.bodyspec.com/n8n/fl/2c54f935efb0d654f44afb5034bc446d';
const finished = 'https://static.bodyspec.com/n8n/fl/4455b8f03cfd04ba7a164517d3406c60';

export const Wrapper: FC<PropsWithChildren<{done?: boolean}>> = ({children, done}) => (
	<Screen>
		<div className={classNames(styles.factoid, styles.interactive)}>
			<div className={styles.image}>
				<img src={done ? finished : pending} />
			</div>
			{children}
		</div>
	</Screen>
);

export const Text: FC<PropsWithChildren> = ({children}) => (
	<div className={styles.text}>
		<p><strong>How was this overview?</strong></p>
		<p>Your answer helps us improve future web experiences.</p>
		{children}
	</div>
);

export const Feedback: FC<{user?: string}> = ({user}) => {
	const [thumbs, setThumbs] = useState<'up' | 'down'>();

	const onClick = async (thumbs: 'up' | 'down') => {
		setThumbs(thumbs);

		if (user) {
			await postValues(Endpoints.flFeedback, {
				user,
				feedback: {thumbs},
			});
		}
	};

	if (thumbs) {
		return (
			<Wrapper done>
				<Text>
					<Thumbs selected={thumbs} onThumbs={onClick} />
					<p><em>Thank you for your feedback!</em></p>
				</Text>
			</Wrapper>
		);
	}

	return (
		<Wrapper>
			<Text>
				<Thumbs onThumbs={onClick} />
			</Text>
		</Wrapper>
	);
};
